export var IWebSocketMessage;
(function (IWebSocketMessage) {
    let Type;
    (function (Type) {
        Type["ECHO_REQUEST"] = "ECHO_REQUEST";
        Type["ECHO_RESPONSE"] = "ECHO_RESPONSE";
        Type["CONVERSATION_UPDATED"] = "CONVERSATION_UPDATED";
        Type["ALERT_BANNER_UPDATED"] = "ALERT_BANNER_UPDATED";
        Type["DRAFT_ORDER_BRAND_EVENT"] = "DRAFT_ORDER_BRAND_EVENT";
        Type["EXPRESS_DELIVERY_UPDATED"] = "EXPRESS_DELIVERY_UPDATED";
        Type["BATCH_OPERATION_UPDATED"] = "BATCH_OPERATION_UPDATED";
        Type["BRAND_NUDGE_TASK_UPDATED"] = "BRAND_NUDGE_TASK_UPDATED";
        /**
         * The duties for the retailer's current cart updated, and they should refetch to display the correct amounts.
         */
        Type["CART_DUTIES_UPDATED"] = "CART_DUTIES_UPDATED";
        /**
         * The shipping costs for a recent cart summary request has been estimated
         */
        Type["CART_SUMMARY_SHIPPING_COSTS_ESTIMATED"] = "CART_SUMMARY_SHIPPING_COSTS_ESTIMATED";
        Type["RETAILER_USER_NOTIFICATION_COUNT_UPDATED"] = "RETAILER_USER_NOTIFICATION_COUNT_UPDATED";
        Type["BRAND_IMAGE_NUDGE_GENERATED"] = "BRAND_IMAGE_NUDGE_GENERATED";
        Type["BRAND_LISTING_NUDGE_GENERATED"] = "BRAND_LISTING_NUDGE_GENERATED";
        Type["BRAND_UPDATED_TO_REVIEW_STATE"] = "BRAND_UPDATED_TO_REVIEW_STATE";
        Type["BRAND_RECEIVED_FIRST_ORDER"] = "BRAND_RECEIVED_FIRST_ORDER";
    })(Type = IWebSocketMessage.Type || (IWebSocketMessage.Type = {}));
    /**
     * Return an instance of IWebSocketMessage with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IWebSocketMessage.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IWebSocketMessage || (IWebSocketMessage = {}));
